<template>
    <h3 class="annual-report-numbers--detail-value u-reset" ref="countUpElement">
        <VueCountUp :end-val="value" :options="countUpOptions" v-if="shouldCountUp"/>
    </h3>
</template>

<script>
    import VueCountUp from 'vue-countup-v2';

    export default {

        components: {
            VueCountUp,
        },
        props: {
            value: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                shouldCountUp: false,
                countUpOptions: {
                    delay: 1000,
                    separator: "'",
                },
            };
        },
        mounted() {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.shouldCountUp = true;
                            observer.unobserve(this.$refs.countUpElement);
                        }
                    });
                },
                {
                    rootMargin: '0px',
                    threshold: 0.1,
                },
            );
            observer.observe(this.$refs.countUpElement);
        },
    };
</script>
